import { ReportFeatures } from '@hcs/types';

export const REPORT_VALUE_TOP_LEVEL_BANNER_FEATURES_SALE: ReportFeatures[] = [
  ReportFeatures.AdjustedAvm,
  ReportFeatures.UserOpinionOfPrice,
];
export const REPORT_VALUE_TOP_LEVEL_BANNER_FEATURES_RENTAL: ReportFeatures[] = [
  ReportFeatures.RentalUserOpinionOfPrice,
];
